import { History } from 'history'
import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'

interface DisplayMessageArgs {
  message: string
}

export const TOOL_NAME = 'display_message_to_user'

export function DisplayMessageToUserToolCall(functionCall: LiveFunctionCall, history: History) {
  const args = functionCall.args as DisplayMessageArgs
  return {
    success: true,
    message: args.message,
  }
}
